(function() {

	angular
		.module('ngmvac')
		.controller('CartController', CartController);

	CartController.$inject = ['$scope', 'Cart', '$window', '$http', '$log', 'ReservationFactory'];

	function CartController($scope, Cart, $window, $http, $log, ReservationFactory) {
		var vm 			= this;
		vm.total 		= 0;
		vm.auto 		= 0;
		vm.cart 		= Cart;
		vm.showFooter 	= true;
		vm.blockAmount = '';
		vm.callBlockAmount = false;
		vm.extraRate = 0;
		vm.carsfeaturesplit = function (features){
			if(features){
				return features.split('<br />');
			}
			else {
				return features;
			}
		}

		if( $window.location.pathname == '/autos/flota' )
			vm.showFooter = false;

		function loadGetCarModal() {
            if(vm.cart.content.length > 1) {
                $('#getCarModal').modal({
                    backdrop: 'static',
                    keyboard: false
                })
            }
		}

		vm.init = function() {
			vm.callBlockAmount = true;
		}

		$scope.$on('extraRate', function(event, extraRate) {
			console.log('extrarate add');
			vm.extraRate = extraRate;
		})

		$scope.$on('cartLoaded', function (event, args) {
		    if (Cart.content.length > 1){
		        vm.auto = (Cart.content.length -1);
			}
			if ( vm.callBlockAmount ) {
				$http.post('/block-amount', {
					provider: Cart.content[vm.auto].proveedor,
					category: Cart.content[vm.auto].categoryName
				}).then(function(response){
					vm.blockAmount = response.data;
				});
			}
			if(localStorage.getItem('cotizadorSeleccionado') == 2) {
				vm.remove(1);
			} else {
				loadGetCarModal();
			}
		});

		$scope.$on('itemCartAdded', function(event, args) {
			vm.total = args.total;
		})

		$scope.$on('itemCartDeleted', function(event, args) {
			vm.total = args.total;
		});

		vm.remove = function (index) {
			vm.cart.remove(index);
			if(index == 2) {
				if(vm.extraRate > 0) {
					ReservationFactory.sendExtraRate('extraRate', vm.cart.content[0].car.mcrRate);
				}
				$('.upgradeCar').hide();
				setTimeout(function(){ 
					$('.upgradeCar').slick({
						slidesToShow: 3,
						slidesToScroll: 3,
						prevArrow: '<a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev" ng-click="$ctrl.prevSlide()"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>',
						nextArrow: '<a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next" ng-click="$ctrl.nextSlide()"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>',
						// prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style=""></button>',
						// nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Previous" role="button" style=""></button>',
						responsive: [
							{
								breakpoint: 1024,
								settings: {
									slidesToShow: 3,
									slidesToScroll: 3,
									infinite: true,
									dots: true
								}
							},
							{
								breakpoint: 600,
								settings: {
									slidesToShow: 2,
									slidesToScroll: 2
								}
							},
							{
								breakpoint: 480,
								settings: {
									slidesToShow: 1,
									slidesToScroll: 1
								}
							}
							// You can unslick at a given breakpoint now by adding:
							// settings: "unslick"
							// instead of a settings object
						]
					  });
					  $('.upgradeCar').show();
					}, 1000);		
			}
		}
	}

	
})();
